<template>
  <div v-if="active" class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Template Settings</p>
        <button class="delete" @click="close"></button>
      </header>
      <section class="modal-card-body">
        <div class="field">
          <label class="label label-new-section">Allow new sections</label>
          <toggle-switch v-model="allowSectionCreation"></toggle-switch>
        </div>
        <div class="field">
          <label class="label label-reorder">Allow sections to be reordered</label>
          <toggle-switch v-model="reorderAllowed"></toggle-switch>
        </div>
        <div class="field">
          <label class="label limit-label">Limit the number of sections</label>
          <toggle-switch v-model="sectionLimitEnabled"></toggle-switch>
          <div class="is-flex input-limit-container">
            <input v-if="!sectionLimitEnabled"  class="input input-section-limit" placeholder="No Limit" :disabled="!sectionLimitEnabled">
            <input v-else class="input input-section-limit" type="number" v-model="sectionLimit">
          </div>
        </div>
        <div class="field">
          <label class="label owner-label">Show Template Owner in team?</label>
          <toggle-switch v-model="addOwnerAsCoOwner"></toggle-switch>
        </div>
        <div class="field mt-1">
          <div class="control">
            <generic-dropdown v-model="displayType" :items="ProjectDisplayTypes" :isUp="true" placeholder="Choose Project Display Type"></generic-dropdown>
          </div>
        </div>
        <div class="field">
          <label class="label label-reorder">Require Categories For Save</label>
          <toggle-switch v-model="requireCategoriesForSave"></toggle-switch>
        </div>
        <div v-if="errorMessage" class="help has-text-danger is-size-6 has-text-centered">{{ errorMessage }}</div>
      </section>
      <div class="modal-card-foot is-flex">
        <div class="modal-buttons">
          <button class="button is-primary is-uppercase ml-3" @click="updateSettings">{{ $t('Done') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GenericDropdown from '@/components/Controls/GenericComponents/dropdown'
import ToggleSwitch from '@/components/Controls/ToggleSwitch'

import componentState from '@/mixins/component-state'
import displayTypes from '@/mixins/project-display-types'

export default {
  mixins: [componentState, displayTypes],
  props: ['project'],
  components: {
    GenericDropdown,
    ToggleSwitch
  },
  data: function () {
    return {
      active: false,
      addOwnerAsCoOwner: true,
      allowSectionCreation: true,
      errorMessage: '',
      displayType: this.DisplayTypeProject,
      reorderAllowed: true,
      sectionLimit: 0,
      sectionLimitEnabled: false,
      requireCategoriesForSave: true
    }
  },
  mounted: function () {
    this.getSettingsFromProject()
  },
  computed: {
  },
  watch: {
    active: function (active) {
      active ? this._callback('lockScrolling', false) : this._callback('unlockScrolling', true)
    }
  },
  methods: {
    cancel: function () {
      this.$emit('modalCancel')
      this.close()
    },
    close: function () {
      this.active = false
    },
    updateSettings: function () {
      if (!this.sectionLimitEnabled) {
        this.sectionLimit = 0
      }
      const data = {
        id: this.project.id,
        createSection: this.allowSectionCreation,
        reorder: this.reorderAllowed,
        maxSections: parseInt(this.sectionLimit),
        displayType: this.displayType,
        ownerAsCoOwner: this.addOwnerAsCoOwner,
        requireCategoriesForSave: this.requireCategoriesForSave
      }
      const id = this.project.id
      this.$store.dispatch('projectUpdateTemplateSettings', { id, data }).then(() => {
        this.close()
      }, (error) => {
        this.errorMessage = error
      })
    },
    getSettingsFromProject: function () {
      this.allowSectionCreation = this.project.createSection
      this.sectionLimit = this.project.maxSections
      this.addOwnerAsCoOwner = this.project.ownerAsCoOwner
      if (this.sectionLimit === 0) {
        this.sectionLimitEnabled = false
      }
      this.reorderAllowed = this.project.reorder
      this.displayType = this.project.displayType
      this.requireCategoriesForSave = this.project.requireCategoriesForSave
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';
.modal-card {
  text-align: center;
  overflow: hidden;
  .title {
    border-bottom: 1px solid #DCDCDC;
    padding: 1.3rem 0;
    font-weight: normal;
    width: 100%;
  }
  .close-button {
    font-size: 1.3rem;
    background-color: transparent;
    opacity: 0.75;
    position: absolute;
    right: 1.25rem;
    top: 0.5rem;
    border: none;
  }
  .submit-questions {
    margin-top: 1rem;
  }
  .modal-card-body {
    height: 100%;
    padding: 2rem 3rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .select {
      width: 90%;
      select {
        display: block;
        width: 100%;
        text-overflow: ellipsis;
        height: 40px;
        font-size: 1rem;
      }
    }
  }
  .template-desc {
    font-size: .875rem;
    color: #373737;
    line-height: 19px;
    min-height: 38px;
    white-space: normal;
  }
  .modal-card-head {
    padding-left: 0;
    padding-right: 0;
  }
  .modal-card-foot {
    justify-content: center;
  }
  .delete {
    position: absolute;
    right: 2%;
  }
  .field {
    padding-bottom: 1rem;
    width: 19rem;
    text-align: left;
    justify-content: space-between;
  }
  .input-limit-container{
    margin-top: 1rem;
    justify-content: center;
  }
  .input-section-limit {
    text-align: center;
    width: 12rem;
  }
  .label {
    display: inline;
    text-align: left;
  }
  .label-new-section {
    padding-right: 6.8rem;
  }
  .label-reorder {
    padding-right: 1.4rem;
  }
  .limit-label {
    padding-right: 2.3rem;
  }
  .owner-label {
    padding-right: 1rem;
  }
}
</style>
